import React from 'react'
import styled from 'styled-components'
import Input from 'components/Form/Input'
import SearchIcon from 'components/icons/SearchIcon'

const StyleInput = styled(Input)`
  .ant-input {
    font-weight: 400;
    font-size: 16px;
    line-height: 24;
    margin-left: 10px;
  }
`

const SearchInput = ({
  searchValue,
  setSearchValue,
  height = '38px',
  width = '70%',
  placeholder = 'Search',
  allowClear,
  suffix = <SearchIcon />,
  prefix = <SearchIcon />,
  bordered = true,
  iconPosition = 'prefix',
  isReport,
  ...rest
}) => {
  return (
    <div style={{ marginTop: '15px', marginBottom: '15px' }}>
      <StyleInput
        {...rest}
        width={width}
        height={height}
        margin={'20px'}
        placeholder={placeholder}
        suffix={iconPosition == 'suffix' && suffix}
        prefix={iconPosition == 'prefix' && prefix}
        allowClear={allowClear}
        bordered={bordered}
      />
    </div>
  )
}
export default SearchInput
